import { render } from "./GrModalMedium.vue?vue&type=template&id=3e70b808&scoped=true"
import script from "./GrModalMedium.vue?vue&type=script&lang=js"
export * from "./GrModalMedium.vue?vue&type=script&lang=js"

import "./GrModalMedium.vue?vue&type=style&index=0&id=3e70b808&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e70b808"]])

export default __exports__